var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      attrs: { top: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    class: _vm.noMargin ? "" : "mr-1",
                    attrs: {
                      icon: !_vm.dark,
                      fab: _vm.dark,
                      dark: _vm.dark,
                      "x-small": _vm.xSmall,
                      small: _vm.small,
                      large: _vm.large,
                      "x-large": _vm.xLarge,
                      color: _vm.color,
                      loading: _vm.loading
                    },
                    on: {
                      click: function($event) {
                        return _vm.emitClick()
                      }
                    }
                  },
                  on
                ),
                [
                  _vm.icon
                    ? _c("v-icon", { attrs: { dark: _vm.dark } }, [
                        _vm._v(_vm._s(_vm.icon))
                      ])
                    : _vm._e(),
                  _vm.text ? [_vm._v(_vm._s(_vm.text))] : _vm._e()
                ],
                2
              )
            ]
          }
        }
      ])
    },
    [_c("span", [_vm._v(_vm._s(_vm.tooltip))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }